import React, { memo, useCallback } from 'react';

import { ReviewsActionBlock } from '@sravni/react-ugc/lib/ReviewsActionBlock';

import { sendGoToWriteReviewEvent } from '../../helpers/analyticsEvents';
import { useFilters } from '../../store/hooks/filters';

export const GiveFeedback = memo(() => {
  const { organizationType } = useFilters();

  const sendEvent = useCallback(() => sendGoToWriteReviewEvent({ organizationType }), [organizationType]);

  return <ReviewsActionBlock handleClickActionButton={sendEvent} organizationType={organizationType} />;
});
